import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-atomic-black pt-20 pb-10 border-t border-white/10" data-id="element-41">
      <div className="container mx-auto px-4 md:px-6" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-43">
          {/* Brand */}
          <div data-id="element-44">
            <a href="/" className="flex items-center gap-3 mb-6" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/nTH6rvmmBYe1TvsMQVLcBV/Atomic_Logo.png" alt="Print Atomic Logo" className="h-10 w-auto" data-id="element-46" />
            </a>
            <p className="text-gray-400 mb-6" data-id="element-47">
              The premier production partner for custom apparel, DTF transfers,
              and embroidery. Built for speed and quality.
            </p>
            <div className="flex gap-4" data-id="element-48">
              <a href="#" className="w-10 h-10 rounded-full bg-atomic-charcoal flex items-center justify-center text-gray-400 hover:bg-atomic-green hover:text-black transition-colors" data-id="element-49">
                <Instagram size={20} data-id="element-50" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-atomic-charcoal flex items-center justify-center text-gray-400 hover:bg-atomic-green hover:text-black transition-colors" data-id="element-51">
                <Facebook size={20} data-id="element-52" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-atomic-charcoal flex items-center justify-center text-gray-400 hover:bg-atomic-green hover:text-black transition-colors" data-id="element-53">
                <Twitter size={20} data-id="element-54" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-55">
            <h4 className="text-white font-bold mb-6" data-id="element-56">Services</h4>
            <ul className="space-y-4" data-id="element-57">
              <li data-id="element-58">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-59">
                  DTF Transfers
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-61">
                  Screen Printing
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-63">
                  Embroidery
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-65">
                  Custom Apparel
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-67">
                  Finishing Services
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-68">
            <h4 className="text-white font-bold mb-6" data-id="element-69">Company</h4>
            <ul className="space-y-4" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-72">
                  About Us
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-74">
                  Get a Quote
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-76">
                  FAQ
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-78">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-80">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-81">
            <h4 className="text-white font-bold mb-6" data-id="element-82">Contact</h4>
            <ul className="space-y-4" data-id="element-83">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-84">
                <MapPin className="text-atomic-green shrink-0 mt-1" size={20} data-id="element-85" />
                <span data-id="element-86">
                  320 Main Street
                  <br data-id="element-87" />
                  Morrice, MI 48857
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-88">
                <Phone className="text-atomic-green shrink-0" size={20} data-id="element-89" />
                <a href="tel:517-414-9232" className="hover:text-atomic-green transition-colors" data-id="element-90">
                  517-414-9232
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-91">
                <Mail className="text-atomic-green shrink-0" size={20} data-id="element-92" />
                <a href="mailto:info@printatomic.com" className="hover:text-atomic-green transition-colors" data-id="element-93">
                  info@printatomic.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-94">
          <p className="text-gray-500 text-sm" data-id="element-95">
            © {new Date().getFullYear()} Print Atomic. All rights reserved.
          </p>
          <p className="text-gray-600 text-sm" data-id="element-96">Designed for production.</p>
        </div>
      </div>
    </footer>;
}